import AsyncComponent from '../../component/asynccomponent/AsyncComponent';
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const login = AsyncComponent(() => import('../../../pages/login/Login'))

const dashboard = AsyncComponent(() =>
  import('../../../pages/dashboard/Dashboard')
)

const budgetForm = AsyncComponent(() =>
  import('../../../pages/budget/BudgetForm')
)

const forbiden = AsyncComponent(() =>
  import('../../../pages/forbiden/Forbiden')
)

const ForgotPassword = AsyncComponent(() =>
  import('../../../pages/password/ForgotPassword')
)

const checkEmail = AsyncComponent(() => import('../../../pages/checkEmail/CheckEmail'))

export default [
  {
    path: '/',
    component: dashboard,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator, RolesEnum.Technician],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired, CompanyTypesEnum.Benefited]
  },
  {
    path: '/budget',
    component: budgetForm,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/login',
    component: login,
    isAuthenticated: false,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator, RolesEnum.Technician],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired, CompanyTypesEnum.Benefited]
  }, 
  {
    path: '/reset-password',
    component: ForgotPassword,
    isAuthenticated: false,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator, RolesEnum.Technician],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired, CompanyTypesEnum.Benefited]
  },
  {
    path: '/forbiden',
    component: forbiden,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator, RolesEnum.Technician],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired, CompanyTypesEnum.Benefited]
  },
  {
    path: '/check-email/:id',
    component: checkEmail,
    isAuthenticated: false,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator, RolesEnum.Technician],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired, CompanyTypesEnum.Benefited]
  }, 
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/DefaultRoutes.js